(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mailsac", [], factory);
	else if(typeof exports === 'object')
		exports["mailsac"] = factory();
	else
		root["mailsac"] = factory();
})(global, function() {
return 